<template>
  <div class="b_dtl_content">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/invoicing'}">结算单</el-breadcrumb-item>
          <el-breadcrumb-item>查看</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="p_employee_box" v-loading="tableLoading">
        <div class="p_employee_list">
          <div class="r_edit_title">
            <div class="line_box"></div>基础信息
          </div>
          <div class="p_employee_form">
            <div class="p_employee_item">
              <p class="emp_txt">结算单编号:</p>
              <div class="emp_form_txt">
                {{statementQuery.finalStatementNo}}
              </div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">归属月:</p>
              <div class="emp_form_txt">
                {{statementQuery.ownershipMonth}}
              </div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">项目/部门:</p>
              <div class="emp_form_txt">
                {{statementQuery.ownershipName}}
              </div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">结算单金额:</p>
              <div class="emp_form_txt">
                ￥{{statementQuery.amount}}
              </div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">已开票金额:</p>
              <div class="emp_form_txt">
                <!-- {{statementQuery.userlabelname}} -->
              </div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">已到款金额:</p>
              <div class="emp_form_txt">
                <!-- {{statementQuery.dtEntryDate}} -->
              </div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">应收账款:</p>
              <div class="emp_form_txt">
                <!-- {{statementQuery.mainuseridname}} -->
              </div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">创建人:</p>
              <div class="emp_form_txt">
                <!-- {{statementQuery.founder}} -->
              </div>
            </div>
            <div class="p_employee_item">
              <p class="emp_txt">创建时间:</p>
              <div class="emp_form_txt">
                <!-- {{statementQuery.mainuseridname}} -->
              </div>
            </div>
          </div>
        </div>
        <div class="p_employee_list">
          <div class="r_edit_title">
            <div class="line_box"></div>已开票信息
          </div>
          <div class="dtl_table">
            <el-table class="post_list" border :data="tableData" style="width:100%">
              <el-table-column align="center" label="开票编号" width="90px">
                <template slot-scope="{row}">
                  <span>{{row.Strmkname}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="开票时间" min-width="110px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                  <span>{{row.Strmkname}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="对方抬头" min-width="110px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                  <span>{{row.Strtype}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="开票主体" min-width="110px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                  <span>{{row.Strtoppowername}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="开票金额" min-width="100px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                  <span>{{row.Strpowername}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="回款金额" min-width="100px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                  <span>{{row.Strpowername}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="发票类型" min-width="100px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                  <span>{{row.Strpowername}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="发票号码" min-width="100px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                  <span>{{row.Strpowername}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="备注" min-width="140px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                  <span>{{row.Strpowername}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="btn_box">
          <el-button type="primary" @click="backHandle">返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import xz from "@/common"
  import moment from 'moment'
  export default {
    name: "updatePost",
    data() {
      return {
        statementQuery: {
          type: 1, //归属类型1：项目2：部门
          ownershipId: "", //归属id
          ownershipMonth: "", //归属月
          amount: 0, //结算单金额
          remark: "", //结算单备注
          fileUrl: "", //结算单附件地址
          finalStatementId: "", //结算单id
          founder: '', //创建人
        },
        tableLoading: false,
        id: '',
        isOver:false,
        tableData: []
      }
    },
    created() {
      if (this.$route.query.id != undefined && this.$route.query.id) {
        this.id = this.$route.query.id;
        this.getDetail();
      }
    },
    methods: {
      // 取消
      backHandle() {
        this.$router.push({
          path: "/invoicing",
        });
      },
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN'
      },
      getDetail() {
        xz.GetFinalStatementEdit(this.id).then(res => {
          try {
            if (res.status == 'ok') {
              this.statementQuery = res.data[0];
              this.statementQuery.ownershipId = Number(this.statementQuery.ownershipId)
              this.stateTitle = '修改结算单';
              this.statementVisible = true
            } else {
              this.$message.error('获取详情出错')
            }
          } catch (e) {
            console.log(e)
          }
        })
      },
    }
  }
</script>
<style scoped>
  .btn_box {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }

  .line_box {
    width: 3px;
    height: 16px;
    background-color: #19bd92;
    margin-right: 4px;
  }

  .dtl_table {
    padding-left: 15px;
    box-sizing: border-box;
    margin-top: 15px;
  }

  .emp_txt {
    width: 90px;
    text-align: right;
    font-size: 14px;
    color: #555;
    padding: 0 10px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .r_edit_title {
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 26px;
    font-weight: bold;
    color: #000;
    border-bottom: 1px solid #DCDFE6;
  }

  .emp_form_txt {
    width: 370px;
    font-size: 14px;
    color: #000;
  }

  .txts01 {
    font-size: 14px;
  }

  .p_employee_item {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    margin-right: 3px;
  }

  .p_employee_form.p_employee_form01 {
    margin-top: 0;
  }

  .p_employee_form {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
  }

  .p_employee_box {
    background-color: #fff;
    padding: 15px 10px;
  }
</style>
<style>
  .e_dtl_content .el-table .el-table__cell {
    padding: 4px 0;
  }
</style>